import React, { useEffect, useState } from "react";
import { X } from "lucide-react";

export default function SideModal({
  title,
  icon: Icon,
  children,
  onClose,
  width = "437px",
  headerClass = "",
  setModalOpen,
  image
}) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setTimeout(() => setVisible(true), 10);
  }, []);

  const handleClose = () => {
    setVisible(false);
    if (setModalOpen) setModalOpen(false);
    setTimeout(onClose, 300); // wait for animation
  };

  return (
    <div className="fixed inset-0 z-50 flex justify-end bg-black bg-opacity-30">
      <div
        className={`bg-white h-full max-w-full shadow-lg transform transition-transform duration-300 ease-in-out ${visible ? "translate-x-0" : "translate-x-full"
          }`}
        style={{ width }}
      >
        <div className={`flex items-center justify-between px-6 py-3 bg-[#EE3B31] text-white ${headerClass}`}>
          <div className="flex items-center gap-3">
            {Icon && (
              <div className="p-4 rounded-full bg-white text-[#EE3B31]">
                <Icon />
              </div>
            )}
            {
              image && (
                <div className="p-4 rounded-full bg-white text-[#EE3B31]">
                  <img src={image} className="h-4 w-4" alt="icon" />
                </div>
              )
            }
            <h2 className="text-lg font-bold">{title}</h2>
          </div>
          <button onClick={handleClose}>
            <X className="w-5 h-5" />
          </button>
        </div>

        <div className="px-6 py-5 overflow-y-auto overflow-x-hidden h-[calc(100%-80px)]">{children}</div>
      </div>
    </div>
  );
}
